import React from 'react'
import { facebook, instagram, linkedin } from '../../assets/imgs'
import './index.css'

const Footer = () =>
  <div className="white bg-dark">
    <div className="footer__content pa3 pa4-m pa5-l m0-auto-l">
      <div className="flex-l flex-row-l justify-flex-start-l mb7-l">
        <address className="fw2 f6 mb4 f4-ns mr7-l">
          The Law Office of Phillip Hamilton, PLLC<br />
          800 Third Avenue<br />
          28th Floor, Suite 2800<br />
          New York, New York 10022<br />
          347-619-3330<br />
          Phil@PhillipHamiltonLaw.com
        </address>

        <div className='mv6 mv0-l'>
          <div className="flex flex-row mb4">
            <a href="https://www.facebook.com/philliphamiltonlaw">
              <img className="footer__social-media-icon mr3" src={facebook} alt="facebook" />
            </a>
            <a href="https://www.instagram.com/philliphamiltonlaw/">
              <img className="footer__social-media-icon mr3" src={instagram} alt="instagram" />
            </a>
            <a href="https://www.linkedin.com/in/philliphamiltonlaw/">
              <img className="footer__social-media-icon mr3" src={linkedin} alt="linkedin" />
            </a>
          </div>
          <a href="https://medium.com/@philliphamilton" className="footer__blog-btn fw2 flex flex-column items-center justify-center white f4">
            <span className='footer__blog-btn-text relative'>
              Read my blog
            </span>
          </a>
        </div>

      </div>

      <div className="fw2 i f8 f6-ns">
        Attorney Advertising. Prior Results Do Not Guarantee Future Outcome.
      </div>
    </div>
  </div>

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/index.js